"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpCardHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var DpCardHeader_styled_1 = require("./DpCardHeader.styled");
var DpCardHeader = function (_a) {
    var title = _a.title, ariaLabelHeader = _a.ariaLabelHeader, openReport = _a.openReport;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    return ((0, jsx_runtime_1.jsxs)(DpCardHeader_styled_1.StyledCardHeader, { children: [(0, jsx_runtime_1.jsx)("h2", { "aria-label": ariaLabelHeader, className: "h4", children: title }), (0, jsx_runtime_1.jsx)("button", { onClick: openReport, "aria-label": t('DpCardHeader.viewAsDataTable'), className: "btn-clearfix", children: t('DpCardHeader.viewAsDataTable') })] }));
};
exports.DpCardHeader = DpCardHeader;
exports.default = exports.DpCardHeader;
